import React from "react";
import PropTypes from "prop-types";
import styles from "./TagMonsterChild.module.css";

/*
 *Displays a tag inside the tag monster
 */
export function TagMonsterChild({
  backgroundColor,
  color,
  children,
  variant = "default",
  selected = false,
  segmentedTheme = "soft",
}) {
  return (
    <div className={styles.container}>
      <button
        style={
          variant === "default"
            ? { backgroundColor: backgroundColor, color: color }
            : undefined
        }
        className={`${styles.button} ${
          variant === "segmented" ? styles.segmented : ""
        } ${
          variant === "segmented" && segmentedTheme === "white"
            ? styles.segmentedWhite
            : ""
        } ${selected ? styles.selected : ""}`}
      >
        {children}
      </button>
    </div>
  );
}

TagMonsterChild.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.any,
  variant: PropTypes.oneOf(["default", "segmented"]),
  selected: PropTypes.bool,
  segmentedTheme: PropTypes.oneOf(["soft", "white"]),
};
